__webpack_require__.p = "https://ptd.gialai.gov.vn/";